import { render } from "./ColumnsChartHorizontal.vue?vue&type=template&id=986b8d38&scoped=true"
import script from "./ColumnsChartHorizontal.vue?vue&type=script&lang=js"
export * from "./ColumnsChartHorizontal.vue?vue&type=script&lang=js"

import "./ColumnsChartHorizontal.vue?vue&type=style&index=0&id=986b8d38&lang=scss&scoped=true"

import exportComponent from "/Applications/dev/FLEXX_FREIGHT/flexx-freight-stats/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-986b8d38"]])

export default __exports__